import React from "react";
import { Col, Container, Row } from "reactstrap";
import EarlyAdmission from "../assets/anthe_early_2025.png";
import EarlyAdmissioniACST from "../assets/earlyAdmissionBenefits.png";
import IATEarly from "../assets/IAT_benefits_2025.png";
import IATEarlt1012 from "../assets/IATEarlt2026.png"
import styles from "./anthe.module.css";
import AKTHEEarly from "../assets/akthe_earlybird_2025.png"
import QRCode from "./QRCode";
function EarlyAdmissionBenefit({ exam_type, class_studying, Response, Qualifycheck, props }) {
  const qr = Response?.centerData?.center_detail?.qr_code;
  return (
    <div style={{ fontFamily: "Outfit-Medium" }} className="pb-4">
      <p className={`text-center font-size-3xl mb-1 mt-4 ${exam_type === "IAT" ? "text-sky-900" : "text-light-blue-200"
        }`}>
        Complete your admission formalities {" "}
        {
          exam_type === "iACST"
            ? "within one month"
            : exam_type === "IAT"
              ? "within one month"
              : "by 31st Dec."
        }
        {" "}to avail attractive
      </p>
      <h2 className={`text-center font-size-45 text-dark-magenta mb-4 fw-bold ${exam_type === "IAT" ? "text-plum-light" : "text-dark-magenta"
        }`}>
        Early Admission Benefits{" "}
      </h2>
      {exam_type === "IAT" ? (
        <>
          {(class_studying === 'VII' ||
            class_studying === 'VIII' ||
            class_studying === 'IX') ? (
            <img
              src={IATEarly}
              style={{ width: "100%" }}
              className="mx-auto d-flex mt-4 mb-4"
              alt="IAT_EARLY_IMG"
            />
          ) : (
            <img
              src={IATEarlt1012}
              style={{ width: "75%" }}
              className="mx-auto d-flex mt-4 mb-4"
              alt="IAT_EARLY_IMG_1012"
            />
          )}
        </>
      ) : exam_type === "AKTHE" ? (
        <img
          src={AKTHEEarly}
          style={{ width: "100%" }}
          className="mx-auto d-flex mt-4 mb-4"
          alt=""
        />
      ) : (
        <div style={{ position: 'relative' }}>
          <img
            src={exam_type === 'iACST' ? EarlyAdmissioniACST : EarlyAdmission}
            style={{ width: "100%" }}
            className="mx-auto d-flex mt-5 mb-5 w-75 h-75"
            alt=""
          />
          {qr && exam_type === 'iACST' && (
            <div style={{ position: 'absolute', right: 12, bottom: '-20px' }}>
              <QRCode qr={qr} />
            </div>
          )}
        </div>
      )}
      <Row>
        <Col lg={12} className={`${exam_type === 'iACST' ? styles.IACST_early_strip : exam_type === "IAT" ? styles.IAT_early_strip : styles.early_strip} p-3 mt-4 mb-3`}>
          <p className="text-black text-center mb-0 font-size-lg">
            The secured scholarship is applicable on classroom courses at any
            Aakash  {exam_type === 'AKTHE'
              ? 'Centre, Kashmir.'
              : (['VII', 'VIII', 'IX'].includes(class_studying) && exam_type === 'IAT')
                ? 'Branches throughout India'
                : 'Branches throughout India'
            }
          </p>
        </Col>
        <Col className="mb-3 text-start">
          {(props?.data?.profile?.class_studying === 'VII' ||
            props?.data?.profile?.class_studying === 'VIII' ||
            props?.data?.profile?.class_studying === 'IX') && (
              <p className="m-0 mt-1">
                *Recorded Video Lectures & Daily Practice Tests are not available
                for students studying in Class {exam_type === "IAT" ? "X" : "VII"}.
              </p>
            )}
          <p>
            <strong>Note:</strong> The above mentioned enrollment benefits will
            vary class-wise.
          </p>
        </Col>
      </Row>
      <Row>
        <div
          className={`${styles.page1_ResultHead}  p-2 w-100 text-center text-white font-size-xxl`}
          style={{ background: exam_type === 'iACST' ? '#029FE1' : exam_type === 'IAT' ? '#029FE1' : '#00008B' }}>
          CHECK LIST FOR COMPLETING ADMISSION FORMALITIES (OFFLINE VISIT)
        </div>
        <Row className="w-100 m-auto px-0">
          <Col
            lg={12}
            className={`${styles.page1_tableHead} dashed-border font-size-xl text-center py-2 px-4`}
          >
            <h4 className="font-size-md text-start my-2">
              {['VII', 'VIII', 'IX'].includes(class_studying)
                ? 'Please note that the following documents should be carried along for completing the admission formalities at any branch of Aakash in India:'
                : 'Please note that the following documents should be carried along for completing the admission formalities at any branch of Aakash INVICTUS in India:'
              }
            </h4>
            <Row lg={12} className="d-flex">
              <Col lg={6}>
                <ul
                  className={`${styles.page1_checklist} text-start font-size-md`}
                >
                  <li>
                    <p>Latest Mark sheet</p>
                  </li>
                  <li>
                    <p>Two recent passport size colour photographs</p>
                  </li>
                </ul>
              </Col>
              <Col lg={6}>
                <ul
                  className={`${styles.page1_checklist} text-start font-size-md`}
                >
                  <li>
                    <p>A valid Photo-ID (Passport, School I-Card etc.)</p>
                  </li>
                  {(exam_type === 'iACST' || exam_type === 'IAT') && (
                    <li>
                      <p>
                        A cheque book in case to avail installment payment mode.
                      </p>
                    </li>
                  )}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
      <Row className="text-center font-size-xl bg-light-grey-100 justify-content-center my-2 p-2">
        SPECIAL ASSISTANCE AVAILABLE FOR COMPLETING ADMISSION FORMALITIES
        ONLINE.
      </Row>
      <Row>
        <Col lg={12} className="text-start mb-2">
          <span className="fw-bold">Please note:</span>
          <ul className={"text-start font-size-md"}>
            <li>
              If at any point of time, the Govt. Charges GST/Service Tax or any
              other tax on Scholarship granted, it will be borne by the Student
              only.
            </li>
            <li>
              The highest amount of scholarship will not exceed 90% of the
              overall fee in any case whatsoever.
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
}

export default EarlyAdmissionBenefit;
